import React, { Component } from "react";
import Phaser from "phaser";
import MainScene from "../gameEngine/scenes/mainScene";
import { layerGround, layerDynamicsItems, layerPnj } from "../gameEngine/maps";
import HealthBar from "./HealthBar";
import "../css/Game.css";

class Game extends Component {
  constructor(props) {
    super(props);
    this.state = {
      safe: true,
      power: 1
    };
  }

  componentDidMount() {
    let config = {
      type: Phaser.AUTO,
      width: window.innerWidth,
      height: window.innerHeight,
      // transparent: true,
      // backgroundColor: "#FFF5EE",
      scene: [
        new MainScene({
          map: {
            layerGround: layerGround,
            layerDynamicsItems: layerDynamicsItems,
            layerPnj: layerPnj
          },
          powerUp: () => {
            this.setState({ power: this.state.power + 1 });
          },
          setSafe: () => {
            this.setState({ safe: true });
          },
          setUnsafe: () => {
            this.setState({ safe: false });
          },
          victory: 4,
          victoryCallBack: () => {
            this.props.history.push("/victory");
          }
        })
      ],
      parent: "game"
    };
    new Phaser.Game(config);
  }

  render() {
    const { safe, power } = this.state;

    return (
      <div className="gameInterface">
        {<div id="game" />}
        <div class="dark-layout" />
        <HealthBar safe={safe} power={power} />
      </div>
    );
  }
}

export default Game;
